import React, { useContext, useEffect, useRef, useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import Sidebar from "components/Sidebar/Sidebar";
import DemoNavbar from "components/Navbars/DemoNavbar";
import Footer from "components/Footer/Footer";
import Navbar from "components/Navbars/nav";
import getRoutes from "./routes";
import { SnackbarContext } from "components/snackBar/SnackbarContext";
import { useTranslation } from "react-i18next";

const Wrapper = styled.div`
  display: flex;
  background-color: #f4f5f7;
`;

const MainPanel = styled(Box)(({ isSidebarCollapsed }) => ({
  flex: 1,
  minHeight: '100vh',
  marginLeft: isSidebarCollapsed ? 80 : 270,
  transition: 'margin-left 0.3s ease',
  backgroundColor: '#F4F5F7',
  position: 'relative',
  overflowY: 'auto',
  overflowX: 'hidden',
  '@media (max-width: 768px)': {
    marginLeft: 0,
    paddingTop: 0
  }
}));

const NavbarWrapper = styled.div`
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1030;
  background-color: white;
  width: 100%;
`;

function SuperAdminLayout() {
  const { t } = useTranslation();
  const routes = getRoutes(t);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const mainPanel = useRef();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { showSnackbar } = useContext(SnackbarContext);

  useEffect(() => {
    if (mainPanel.current) {
      mainPanel.current.scrollTop = 0;
    }
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  return (
    <Wrapper>
      <Sidebar
        routes={routes}
        isMobile={isMobileSidebarOpen}
        isSidebarCollapsed={isSidebarCollapsed}
        onClose={() => setIsMobileSidebarOpen(false)}
        onOpen={() => setIsMobileSidebarOpen(true)}
        setIsSidebarCollapsed={setIsSidebarCollapsed}
        onToggleSidebar={(v) => setIsSidebarCollapsed(v)}
      />
      <MainPanel ref={mainPanel} isSidebarCollapsed={isSidebarCollapsed} id="superadmin-main">
        <NavbarWrapper>
          <DemoNavbar />
        </NavbarWrapper>
        <div style={{ width: '100%' }}>
          <Navbar title={t('superAdmin.layout.superAdmin')} onMenuClick={() => setIsMobileSidebarOpen(!isMobileSidebarOpen)} />
          <Routes>
            {routes.map((prop, key) => {
              const path = prop.path.endsWith('/*') ? prop.path : `${prop.path}/*`;
              return (
                <Route path={path} element={prop.component} key={key} />
              );
            })}
            <Route index element={<Navigate to="/superadmin/dashboard" replace />} />
          </Routes>
        </div>
        <Footer fluid />
      </MainPanel>
    </Wrapper>
  );
}

export default SuperAdminLayout;


